import {IntermediatePart} from "../../intermediatePart";

export default class Countertop extends IntermediatePart {

  constructor(isChild) {
    super(isChild);
    this.partId = 'countertop';
    this.partName = 'Countertop';
    this.translateId = "visualizer.kitchen.countertop.countertop";
    this.isStoneFeature = true;
    this.canBeDisabled = true;
  }

}
